// Define a basic Action interface
interface Action<T = unknown> {
    type: string;
    data?: T;
}

export function fetchCategory(
    state = null,
    action: Action<Array<{ id: string; name: string }>>
) {
    switch (action.type) {
        case 'FETCHED_CATEGORIES':
            return action.data;
        default:
            return state;
    }
}

export function updateProfile(
    state = false,
    action: Action<{ id: string; name: string; email: string }>
) {
    switch (action.type) {
        case 'PROFILE_UPDATED':
            return true;
        default:
            return false;
    }
}

export function fetchNewCollection(
    state = null,
    action: Action<{ id: string; name: string; description: string }>
) {
    switch (action.type) {
        case 'CREATE_COLLECTION':
            return action.data;
        default:
            return state;
    }
}

export function fetchUserNFT(
    state = null,
    action: Action<Array<{ id: string; name: string; image: string }>>
) {
    switch (action.type) {
        case 'FETCHED_USER_NFT':
            return action.data;
        default:
            return state;
    }
}

export function fetchUserDraftNFT(
    state = null,
    action: Action<Array<{ id: string; name: string; image: string }>>
) {
    switch (action.type) {
        case 'FETCHED_USER_DRAFT_NFT':
            return action.data;
        default:
            return state;
    }
}

export function fetchSingleNFTDetails(
    state = null,
    action: Action<{
        id: string;
        name: string;
        description: string;
        image: string;
    }>
) {
    switch (action.type) {
        case 'FETCHED_SINGLE_NFT_DETAILS':
            return action.data;
        default:
            return state;
    }
}

export function fetchProfile(
    state = null,
    action: Action<{ id: string; name: string; email: string; avatar: string }>
) {
    switch (action.type) {
        case 'FETCHED_PROFILE':
            return action.data;
        case 'PROFILE_UPDATED':
            return action.data;
        default:
            return state;
    }
}

export function fetchReferralDashboard(state = { loading: false, data: null, error: null }, action: any) {
  switch (action.type) {
    case "FETCHED_REFERRAL_DASHBOARD":
      return { loading: false, data: action.data, error: null };
    default:
      return state;
  }
}

export function isRewardClaimed(
    state = { isClaimed: false },
    action: Action<{ isClaimed: boolean }>
) {
    switch (action.type) {
        case 'IS_REWARD_CLAIMED':
            return action.data;
        default:
            return state;
    }
}

export function fetchLikesCount(
    state = { count: 0 },
    action: Action<{ count: number }>
) {
    switch (action.type) {
        case 'FETCHED_LIKES_COUNT':
            return action.data;
        default:
            return state;
    }
}

export function fetchLikeToggled(
    state = null,
    action: Action<{ success: boolean }>
) {
    switch (action.type) {
        case 'FETCHED_LIKE_TOGGLED':
            return action.data;
        default:
            return state;
    }
}

export function fetchIsLiked(
    state = { isFollowed: false },
    action: Action<{ isFollowed: boolean }>
) {
    switch (action.type) {
        case 'FETCHED_IS_LIKED':
            return action.data;
        default:
            return state;
    }
}

export function fetchIsFollow(
    state = { isFollowed: false },
    action: Action<{ isFollowed: boolean }>
) {
    switch (action.type) {
        case 'FETCHED_IS_FOLLOW':
            return action.data;
        default:
            return state;
    }
}

export function fetchLikedNFT(
    state = null,
    action: Action<Array<{ id: string; name: string; image: string }>>
) {
    switch (action.type) {
        case 'FETCHED_LIKED_NFT':
            return action.data;
        default:
            return state;
    }
}

export function fetchCollectedNFT(
    state = null,
    action: Action<Array<{ id: string; name: string; image: string }>>
) {
    switch (action.type) {
        case 'FETCHED_COLLECTED_NFT':
            return action.data;
        default:
            return state;
    }
}

export function fetchRentalEarnings(
    state = null,
    action: Action<Array<{ id: string; name: string; image: string }>>
) {
    switch (action.type) {
        case 'FETCHED_RENTAL_EARNINGS':
            return action.data;
        default:
            return state;
    }
}
export function fetchCollectionNFT(
    state = null,
    action: Action<Array<{ id: string; name: string; image: string }>>
) {
    switch (action.type) {
        case 'FETCHED_COLLECTION_NFT':
            return action.data;
        default:
            return state;
    }
}

export function fetchNFTEditionHistory(
    state = null,
    action: Action<Array<{ id: string; timestamp: string; action: string }>>
) {
    switch (action.type) {
        case 'FETCHED_NFT_EDITION_HISTORY':
            return action.data;
        default:
            return state;
    }
}

export function fetchNotifications(
    state = null,
    action: Action<Array<{ id: string; message: string; timestamp: string }>>
) {
    switch (action.type) {
        case 'FETCHED_NOTIFICATIONS':
            return action.data;
        default:
            return state;
    }
}

export function fetchProfileBanner(
    state = null,
    action: Action<{ id: string; image: string }>
) {
    switch (action.type) {
        case 'FETCHED_PROFILE_BANNERS':
            return action.data;
        default:
            return state;
    }
}

export function fetchLanguage(state = 'en', action: Action<string>) {
    switch (action.type) {
        case 'SET_LANGUAGE':
            return action.data;
        default:
            return state;
    }
}

export function verified_by_instagram(
    state = null,
    action: Action<{ verified: boolean; username: string }>
) {
    switch (action.type) {
        case 'VERIFIED_BY_INSTAGRAM':
            return action.data;
        default:
            return state;
    }
}

export function fetch_twitter_access_token(
    state = null,
    action: Action<{ token: string; secret: string }>
) {
    switch (action.type) {
        case 'TWITTER_ACCESS_TOKEN':
            return action.data;
        default:
            return state;
    }
}

export function verified_by_twitter(
    state = null,
    action: Action<{ verified: boolean; username: string }>
) {
    switch (action.type) {
        case 'VERIFIED_BY_TWITTER':
            return action.data;
        default:
            return state;
    }
}

export function isLoader(
    state = { isLoading: false },
    action: Action<{ isLoading: boolean }>
) {
    switch (action.type) {
        case 'IS_LOADER':
            return action.data;
        default:
            return state;
    }
}

export function fetchRewardClaimSummary(state = null, action: Action<any>) {
    switch (action.type) {
        case 'FETCHED_REWARD_CLAIM_SUMMARY':
            return action.data;
        default:
            return state;
    }
}

export function fetchInvestPoolSummary(state = null, action: Action<any>) {
    switch (action.type) {
        case 'FETCHED_INVEST_POOL_SUMMARY':
            return action.data;
        default:
            return state;
    }
}

export function fetchTransactionHistory(state = null, action: Action<any>) {
    switch (action.type) {
        case 'FETCHED_TRANSACTION_HISTORY':
            return action.data;
        default:
            return state;
    }
}

export function fetchSecondaryMarketplaceMetrics(
    state = null,
    action: Action<any>
) {
    switch (action.type) {
        case 'FETCHED_SECONDARY_MARKETPLACE_METRICS':
            return action.data;
        default:
            return state;
    }
}

export function fetchRentalSummary(state = null, action: Action<any>) {
    switch (action.type) {
        case 'FETCHED_RENTAL_SUMMARY':
            return action.data;
        default:
            return state;
    }
}

// amenities id->name map
export function fetchAmenitiesById(
    state: Record<string, string> = {},
    action: Action<Record<string, string>>
) {
    switch (action.type) {
        case 'FETCHED_AMENITIES_BY_ID':
            return { ...state, ...(action.data || {}) };
        default:
            return state;
    }
}
